import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import warning from "../../assets/icons/warning.png";

export const Third = (props) => {
  const validate = () => {
    if (window.confirm("Are you sure you want to go back?")) {
      // eslint-disable-line
      props.previousStep();
    }
  };

  const [state, setState] = useState({
    tagline: "",
    bio: "",
    teachingStyle: "",
  });

  // step3: {
  //   tagline: "I am passionate about teaching",
  //   bio:
  //     "I love to teach - Helping students understand comlicated concepts and ideas of course, their success makes it worthwile. I graduated from the University of Liverpool, Liverpool with a B.Sc in Mathetematics and Finance. I am a full time tutor",
  //   teachingStyle:
  //     "I am determined to lean how I could help students who are not doing well in traditional classroom settings. As a result, I tailor my session",
  // },

  const submitStep3Info = (isCallApi) => {
    const { TutorInfoObj } = props;
    const { tagline, bio, teachingStyle } = state;
    let step3 = {
      tagline,
      bio,
      teachingStyle,
    };
    TutorInfoObj.step3 = step3;
    TutorInfoObj.step3 = step3;
    props.AddTutorInfo(TutorInfoObj);
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
    // if (tagline && bio && teachingStyle) {
    //   TutorInfoObj.step3 = step3;
    //   props.AddTutorInfo(TutorInfoObj);
    //   return true;
    // } else {
    //   return false;
    // }
  };

  const onGetTxt = (event, limit) => {
    if (event.target.value.length <= limit) {
      setState({
        ...state,
        [event.target.id]: event.target.value,
      });
    }
  };

  useEffect(() => {
    let { tagline, bio, teachingStyle } = state;
    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    tagline = TutorInfoObj?.step3?.tagline;
    bio = TutorInfoObj?.step3?.bio;
    teachingStyle = TutorInfoObj?.step3?.teachingStyle;

    if (!tagline) {
      tagline = "";
    }

    setState((state) => ({
      ...state,
      tagline,
      bio,
      teachingStyle,
    }));
    if (props.funcStatus === "loading..." && props.currentStep === 3) {
      submitStep3Info(true);
    }
  }, [props]);

  let { tagline, bio, teachingStyle } = state;
  const { iscompletedForm, validationError } = props;

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <Row className="m-0">
      <WizardSteps step={3} {...props} previousStep={validate} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col lg={12} md={12} sm={12} xs={12} className="subject-mode bio">
              <h1 className="step-title">Profile tagline</h1>
              <h2 className="step-subtitle">
                Write a short summary to promote yourself
              </h2>

              <Form.Control
                className={
                  !tagline
                    ? validationError?.data?.tagline
                      ? "form_textarea input errorInput"
                      : "form_textarea input"
                    : "form_textarea input"
                }
                id="tagline"
                type="text"
                placeholder="E.g. A desire to make biology exciting for all learners"
                onChange={(e) => onGetTxt(e, 70)}
                value={tagline}
                style={{ height: "56px" }}
                disabled={!iscompletedForm ? false : true}
              />
              <div className="error">
                {!tagline
                  ? validationError?.data?.tagline
                    ? warningError
                    : ""
                  : ""}
                {!tagline
                  ? validationError?.data?.tagline
                    ? validationError?.data?.tagline
                    : ""
                  : ""}
              </div>

              <label className="limitLabel">
                {`${tagline?.length ? tagline?.length : 0}/70`}
              </label>

              <h1 className="step-title" style={{ marginTop: "19px" }}>
                Tell us about yourself
              </h1>
              <h2 className="step-subtitle">
                Describe yourself and your tutoring journey to parents and
                students
              </h2>

              <Form.Control
                className={
                  !bio
                    ? validationError?.data?.bio
                      ? "form_textarea input errorInput"
                      : "form_textarea input"
                    : "form_textarea input"
                }
                id="bio"
                as="textarea"
                placeholder="Write a brief description about your self, your tutoring journey and what makes you unique."
                value={bio}
                onChange={(e) => onGetTxt(e, 750)}
                style={{ height: "110px" }}
                disabled={!iscompletedForm ? false : true}
              />
              <div className="error">
                {!bio ? (validationError?.data?.bio ? warningError : "") : ""}
                {!bio
                  ? validationError?.data?.bio
                    ? validationError?.data?.bio
                    : ""
                  : ""}
              </div>

              <label className="limitLabel">
                {`${bio?.length ? bio?.length : 0}/750`}
              </label>

              <h1 className="step-title" style={{ marginTop: "19px" }}>
                Tell us about your teaching style
              </h1>
              <h2 className="step-subtitle">
                Describe how you will teach and cater for individuals with
                different learning styles to parents and students.
              </h2>

              <Form.Control
                className={
                  !teachingStyle
                    ? validationError?.data?.teachingStyle
                      ? "form_textarea input errorInput"
                      : "form_textarea input"
                    : "form_textarea input"
                }
                id="teachingStyle"
                as="textarea"
                placeholder="Write the subject or subjects and how you’ll teach them."
                value={teachingStyle}
                onChange={(e) => onGetTxt(e, 350)}
                style={{ height: "112px" }}
                disabled={!iscompletedForm ? false : true}
              />
              <div className="error">
                {!teachingStyle
                  ? validationError?.data?.teachingStyle
                    ? warningError
                    : ""
                  : ""}
                {!teachingStyle
                  ? validationError?.data?.teachingStyle
                    ? validationError?.data?.teachingStyle
                    : ""
                  : ""}
              </div>

              <label className="limitLabel" style={{ marginBottom: "0px" }}>
                {`${teachingStyle?.length ? teachingStyle?.length : 0}/350`}
              </label>
            </Col>
          </Row>
          <Nextsteps step={3} {...props} submitStepInRedux={submitStep3Info} />
        </div>
      </Col>
    </Row>
  );
};
